import Skeleton from "react-loading-skeleton";

export const ExpressShipping = ({ shipCost }) => {
  return (
    <div className="shipping-method express-shipping">
      <div className="shipping-method-info">
        <div>
          <input className="form-check-input" type="radio" name="shippingMethod" id="shippingMethod2" disabled={true} />
        </div>
        <label className="form-check-label" htmlFor="shippingMethod2">
          <div className={"d-flex justify-content-between align-items-center"}>
            <div>Express Shipping</div>
            <div>
              <Skeleton width={50} />
            </div>
          </div>
        </label>
      </div>
    </div>
  );
};
